var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "app-modal",
        {
          attrs: { titulo: _vm.titulo, width: 1200, height: 700 },
          on: { closeModal: _vm.closeModal }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "validation-observer",
                { ref: "validation", attrs: { tag: "div" } },
                _vm._l(_vm.laudos, function(laudo, index) {
                  return _c(
                    "el-collapse",
                    { key: index },
                    [
                      _c(
                        "el-collapse-item",
                        { staticClass: "content", attrs: { name: laudo.id } },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.getLabel(laudo),
                                    placement: "top"
                                  }
                                },
                                [
                                  !laudo.aptoParaGerar
                                    ? _c("i", {
                                        staticClass:
                                          "header-icon el-icon-warning warning-icon"
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Apto para gerar",
                                    placement: "top"
                                  }
                                },
                                [
                                  laudo.aptoParaGerar
                                    ? _c("i", {
                                        staticClass:
                                          "header-icon el-icon-success success-icon"
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(
                                _vm._s(
                                  "Laudo do processo " + laudo.numeroProcesso
                                )
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-card",
                            {
                              staticClass: "content",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _c("app-divider", {
                                staticClass: "margim-bottom",
                                attrs: { label: "Dados do processo" }
                              }),
                              _c(
                                "div",
                                { staticClass: "filter-row" },
                                [
                                  _c("app-par", {
                                    attrs: {
                                      chave: "Número do processo",
                                      valor: laudo.numeroProcesso
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarProcesso(laudo)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c("i", { staticClass: "fal fa-eye" }),
                                        _vm._v("  Visualizar Processo")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Número da OS",
                                      content: laudo.dadoLaudoDto.numeroOS,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "numeroOS",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Data vistoria",
                                      content: laudo.dataVistoria,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo,
                                          "dataVistoria",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("app-divider", {
                                staticClass: "margim-bottom",
                                attrs: { label: "Dados do interessado" }
                              }),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Nome",
                                      content:
                                        laudo.dadoLaudoDto.nomeRazaoSocial,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "nomeRazaoSocial",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "CPF",
                                      content: laudo.dadoLaudoDto.cpfCnpj,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "cpfCnpj",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Estado civil",
                                      content: laudo.dadoLaudoDto.estadoCivil,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "estadoCivil",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Telefones",
                                      content: laudo.dadoLaudoDto.telefones,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "telefones",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Email",
                                      content: laudo.dadoLaudoDto.email,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "email",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Renda familiar",
                                      content: laudo.dadoLaudoDto.renda,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "renda",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("app-divider", {
                                staticClass: "margim-bottom",
                                attrs: {
                                  label: "Informação de localização do imóvel"
                                }
                              }),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Nome do imóvel",
                                      content: laudo.dadoLaudoDto.nomeImovel,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "nomeImovel",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Município do imóvel",
                                      content:
                                        laudo.dadoLaudoDto.municipioImovel,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "municipioImovel",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Localização",
                                      content:
                                        laudo.dadoLaudoDto.localizacaoImovel,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "localizacaoImovel",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("app-divider", {
                                staticClass: "margim-bottom",
                                attrs: { label: "Dados da ocupação" }
                              }),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Há ocupantes anteriores?",
                                      content:
                                        laudo.dadoLaudoDto.ocupantesAnterior,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "ocupantesAnterior",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Tem posse mansa e pacífica?",
                                      content:
                                        laudo.dadoLaudoDto
                                          .temPosseMansaPacifica,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "temPosseMansaPacifica",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label:
                                        "É uma unidade autônoma produtiva e sem fracionamento?",
                                      content:
                                        laudo.dadoLaudoDto
                                          .unidadeAutomaProdutivaSemFracionamento,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "unidadeAutomaProdutivaSemFracionamento",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("app-divider", {
                                staticClass: "margim-bottom",
                                attrs: { label: "Dados da ocupação" }
                              }),
                              _c(
                                "el-row",
                                [
                                  _c("app-display-com-input", {
                                    attrs: {
                                      marginBottom: true,
                                      label: "Tem atividade agrária?",
                                      content:
                                        laudo.dadoLaudoDto.temAtividadeAgraria,
                                      name: "index_" + index + "_"
                                    },
                                    on: {
                                      "update:content": function($event) {
                                        return _vm.$set(
                                          laudo.dadoLaudoDto,
                                          "temAtividadeAgraria",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("app-documentos", {
                                attrs: {
                                  idUploadDocumento: "documentos" + index,
                                  titulo: "Documetos",
                                  maxSize: 25000,
                                  "valid-extensions": [
                                    "png",
                                    "jpg",
                                    "jpeg",
                                    "zip"
                                  ],
                                  documentos: laudo.documentos,
                                  tiposDocumentos: _vm.tiposDocumento,
                                  tiposDocumentosObrigatorios:
                                    _vm.tiposDocumento,
                                  removeOutros: true,
                                  idLaudoDiagnostico: laudo.id,
                                  observer: _vm.$refs.validation,
                                  aba: "index_" + index + "_"
                                }
                              }),
                              _c(
                                "el-row",
                                { staticClass: "filter-row" },
                                [
                                  _c("app-button", {
                                    attrs: {
                                      titulo: "Salvar análise",
                                      tipo: "success",
                                      size: "medium",
                                      icone: "times-circle",
                                      method: "salvar"
                                    },
                                    on: {
                                      salvar: function($event) {
                                        return _vm.salvar(laudo, index)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-639d7d27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639d7d27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/diagnostico/AppModalLaudo.vue
// module id = null
// module chunks = 